import OldReportMediator from './OldReportMediator'
import {ReportType} from './constants'
import StaffOutputReportEditConfigController from './edit_config_controller/staffOutput/StaffOutputReportEditConfigController'
import makeRpcCall from '../util/jquery_rpc'
import messageResource from '../messageResource'
import ReportPrintableHeadersBuilder from './ReportPrintableHeadersBuilder'
import LoadingPopup from '../LoadingPopup'

export default function StaffOutputReportMediator ()
{
    this.constructor = StaffOutputReportMediator;
}

StaffOutputReportMediator.prototype = _.create(OldReportMediator.prototype);

StaffOutputReportMediator.prototype.init = function ( config )
{
    OldReportMediator.prototype.init.call( this, config );

    this._loadingDataPopup = new LoadingPopup().init('commentsDataLoadingPopup');
    this.commentsLightBoxPopupId = 'commentsLightBox';

    return this;
};

StaffOutputReportMediator.prototype.getReportType = function()
{
    return ReportType.STAFF_PERFORMANCE;
};

StaffOutputReportMediator.prototype.initEditConfigController = function( config )
{
    const self = this;
    return new StaffOutputReportEditConfigController().init(
            {
                reportParameters: config.reportParameters,
                reportAuthorizationInfo: config.reportAuthorizationInfo,
                users: config.users,
                manageableUsersIds: config.manageableUserIds,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                changeCallback: function(){ self.changeParametersCallback(); }
            } );
};

// show comments popup (make RPC call for loading comments)
StaffOutputReportMediator.prototype.showCommentsPopup = function( identity, whoseCommentsId ) {
    this._loadingDataPopup.show();
    const self = this;
    // fill parameters for rpc call
    const params = [identity, whoseCommentsId, this.reportParameters.customersProjectsSelection, this.reportParameters.dateRangeSelection, this.reportParameters.timeApprovalStatus ];

    makeRpcCall(
        "RetrieveCommentsService.getComments",
        params,
        function( result ) { self._successLoadingUserComments( result );},
        function( jqXHR, textStatus, errorThrown ) {
            if ( self._errorLoadingUserComments( jqXHR, textStatus, errorThrown ) )
                return true;
        }
    )
};

// if data loading init comments popup and show
StaffOutputReportMediator.prototype._successLoadingUserComments = function (userCommentsData) {
    const commentsPopup = new ShowCommentsLightBox().init(userCommentsData, this.commentsLightBoxPopupId, this.reportParameters.timeFormat);
    // callback for close button
    commentsPopup.setCancelCallback(function() {
       commentsPopup.hide();
    });
    this._loadingDataPopup.hide(); // hide spinner
    commentsPopup.show();
};
// error handler
StaffOutputReportMediator.prototype._errorLoadingUserComments = function ( jqXHR, textStatus, errorThrown ) {
    this._loadingDataPopup.hide(); // hide spinner

    if( this._noRightsHandler(errorThrown) )
        return true;

    if (errorThrown.exception && errorThrown.exception === 'com.actimind.actitime.administration.NoSuchUserException') {
        alert(messageResource.getMessage("report_comments.no_such_user"));
        return true;
    }
};

StaffOutputReportMediator.prototype._populateHeadersArray = function( headersArray ) {
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray( this.reportParameters.customersProjectsSelection, headersArray ); //customers and projects
    this.printableHeadersBuilder.addStaffSelectionParamsToArray( this.reportParameters.userSelection, headersArray ); //staff
    this.printableHeadersBuilder.addTimeApprovalStatusToArray( this.reportParameters.timeApprovalStatus, headersArray ); //time approval status
};

StaffOutputReportMediator.prototype.initPrintableHeadersBuilder = function ( config ) {
    return new ReportPrintableHeadersBuilder().init({
                users: config.users,
                reportParameters: config.reportParameters,
                cpList: config.cpList,
                isFilteredByAssignments: config.isFilteredByAssignments,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
            },
    );
};


// WEBPACK FOOTER //
// ./web/js/reports/StaffOutputReportMediator.js